import React from "react";
import { getStockMessage, isSchoolUser, isInternal } from '../helpers.mjs';
import AddToBasket from './AddToBasket.js';
import OrderTrackIcons from './OrderTrackIcons.js';
import OfferLink from './OfferLink.js';
import { useElasticData, useExtraData } from "./DataContext.js";

const BookControls = () => {
    let { elasticData, product } = useElasticData();
    let { extraData, _source, isGuestUser, isLibraryUser, isSchoolsUser, isForSchoolBasket } = useExtraData();

    if (!extraData) {
        return null;
    }

    const pds = elasticData;
    let productRrp = new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(pds.isbookpack == 1 ? (100 * pds.rrp / (100 - extraData.discount)) : pds.rrp);
    let productPrice = extraData.price;
    let orderedBefore = extraData.orderedBefore;
    let productDiscount = extraData.discount;
    let stockText = getStockMessage(pds);
    let isForSchoolBasketRes = isForSchoolBasket();
    const isLibraryUserAndNotBookPack = (isLibraryUser() && _source.isbookpack != 1);
    let isSchoolUserRes = isSchoolUser();
    let isInternalUserRes = isInternal();

    var offerLink = null;
    if (isSchoolUserRes || isForSchoolBasketRes) {
        if (extraData.offerPage != null) {
            offerLink = <OfferLink link={"/" + extraData.offerPage} heading="Special offer" name={extraData.offerGroupName} ofId={extraData.offerGroupId} />
        } else if (extraData.offerMinQuantity > 1) {
            offerLink = <OfferLink link={null} heading="Class set offer" name={`Order ${extraData.offerMinQuantity} or more copies of this title and get ${extraData.offerDiscount}% off the RRP`} ofId={extraData.offerGroupId} />
        } else if (extraData.offerGroupName) {
            offerLink = <OfferLink link={null} heading="Special offer" name={extraData.offerGroupName} ofId={extraData.offerGroupId} />
        }
    }

    return (
        <div className={`${isLibraryUserAndNotBookPack ? 'bookControls' : 'deliveryInfo'}`}>
            <h3 className="bookPrice">{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(productPrice)}</h3>
            <div className="pricingBreakdown">
                <p className="rrp">
                    <strong>RRP&nbsp;{productRrp}</strong>
                    {productDiscount > 0 && <span className="savingPercent">{Intl.NumberFormat("en-GB", { style: "percent", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(productDiscount / 100)}</span>}
                </p>
            </div>

            {orderedBefore && <div className="pricingBreakdown">
                <a href={`/isbn?isbn=${pds.id}`} target="_blank"><i style={{ color: '#ff006d' }} className="fas fa-shopping-basket" title="This title has been ordered before, or is currently in another basket"></i></a>
            </div>}
            {stockText && <div className="stockSection" dangerouslySetInnerHTML={{ __html: stockText }} />}
            {(isSchoolUserRes || isForSchoolBasketRes) && (isInternalUserRes || pds.hasstock == "1") && <div class="quantitySection">
                <p>Quantity <input class={`bookQuantity productQty${(isInternalUserRes && pds.hasstock == "0") ? " productQtyOutOfStock" : ""}`} type="number" max="999" defaultValue={1} placeholder="0" maxLength={3} min={1} /></p>
            </div>}
            {/* if (!LibrariesCharging::isApplicable()) 
            <div className="quantitySection">
                <p>Quantity&nbsp;<input className="bookQuantity productQty" type="number" max="[$maxQty]" value="[$defaultValue]" placeholder="0" maxlength="3" /></p>
            </div>
            */}

            <AddToBasket product={product} hit={elasticData} />
            {offerLink !== null && <div className="offerDetails offerDetailsBookPage">
                {offerLink}
            </div>}
            <OrderTrackIcons />
        </div>
    );
}

export default BookControls;
